import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import { getAvailableQuantity } from 'shared/order/bogo/common';

const issueDiscountBundleRewards = (bogoCalcsData, bogoSpecial, conditionsManager) => {
  const { discountBundle, specialId } = bogoSpecial;
  const { discountType, value } = discountBundle;
  let rewardsSatisfiers = {};

  _.forEach(conditionsManager.satisfiers, ({ item, quantity }) => {
    let quantityToDiscount = quantity;
    // if we have a limit we want to use that as the quantityToDiscount for this pass
    // unless the limit is greater than the availableQuantity
    // if there is a leftover that doesn't divide evenly across the limit
    // we don't want to include that remainder quantity
    if (discountBundle?.limit) {
      const availableQuantity = getAvailableQuantity({
        item,
        bogoCalcsData,
        pendingConditionsSatisfiers: {},
        pendingRewardsSatisfiers: rewardsSatisfiers,
        specialId: bogoSpecial.specialId,
      });
      const lesserOfAvailableAndLimit = Math.min(availableQuantity, discountBundle?.limit);
      if (availableQuantity >= discountBundle?.limit) {
        quantityToDiscount = lesserOfAvailableAndLimit;
        bogoCalcsData.ignoreConditionsForDiscountBundle = true;
      } else {
        quantityToDiscount = lesserOfAvailableAndLimit % discountBundle?.limit === 0 ? lesserOfAvailableAndLimit : 0;
      }
    }

    if (quantityToDiscount > 0) {
      rewardsSatisfiers = {
        [item.key]: {
          item,
          quantity: quantityToDiscount,
          rewards: {
            [discountBundle._id]: {
              quantity: quantityToDiscount,
              reward: {
                _id: discountBundle._id,
                quantity: quantityToDiscount,
                [discountType]: value,
              },
              discountBundle: { ...discountBundle },
              specialId,
            },
          },
        },
      };
    }
  });

  return rewardsSatisfiers;
};

export default issueDiscountBundleRewards;
